//* Styles
import SkeletonFaqStyle from './style';

//* Component
import { Image } from '@weareconceptstudio/core';

const SkeletonFaq = () => {
	return (
		<SkeletonFaqStyle>
			<Image src={'/images/skeleton-faq.svg'} />
		</SkeletonFaqStyle>
	);
};

export default SkeletonFaq;
